import styled from "styled-components";

export const Divider = styled.div`
	width: calc(100% - 16px);
	height: 1px;
	margin: 0 8px 0 8px;
	border-radius: 1px;
	background-color: var(--color-outline);
`;

export const Space = styled.div`
	flex: 1 1 auto;
`;

/* Cards [START] */
const BaseCardLayout = styled.div`
	border-radius: 12px;
	padding: 12px 16px;
	text-align: start;
	overflow: hidden;
	opacity: ${(props) => (props.isDisabled ? "0.4" : "1")};
	-webkit-user-select: none;
	user-select: none;
	pointer-events: ${(props) => (props.isDisabled ? "none" : "auto")};
	cursor: ${(props) => (props.notHover ? "unset" : "pointer")};
`;

export const ElevatedCard = styled(BaseCardLayout)`
	background: var(--color-surface-container-low);
	box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
	transition: 0.3s;

	${(props) =>
		props.notHover
			? ""
			: "&:hover { background: var(--color-surface-container-highest); }"}
`;

export const OutlineCard = styled(BaseCardLayout)`
	border: 2px solid var(--color-outline);
	transition: 0.3s;

	${(props) =>
		props.notHover
			? ""
			: "&:hover { background: var(--color-surface-container-highest); }"}
`;
/* Cards [END] */

/* Alert box [START] */
const AlertBoxBase = styled.div`
	display: flex;
	flex-direction: row;
	gap: 12px;
	align-items: center;
	padding: 8px 16px;
	border-radius: 6px;
	-webkit-user-select: none;
	user-select: none;
	font-style: var(--md-sys-typescale-body-medium-font-family-style);
	font-weight: var(--md-sys-typescale-body-medium-font-weight);
	font-size: var(--md-sys-typescale-body-medium-font-size);
	letter-spacing: var(--md-sys-typescale-body-medium-tracking);
	line-height: var(--md-sys-typescale-body-medium-height);
	text-transform: var(--md-sys-typescale-body-medium-text-transform);
	text-decoration: var(--md-sys-typescale-body-medium-text-decoration);
`;

export const WaringAlertBox = styled(AlertBoxBase)`
	color: var(--color-warning-on-container);
	background: var(--color-warning-container);
`;

export const TipAlertBox = styled(AlertBoxBase)`
	color: var(--color-tip-on-container);
	background: var(--color-tip-container);
`;

export const SuccessAlertBox = styled(AlertBoxBase)`
	color: var(--color-success-on-container);
	background: var(--color-success-container);
`;

export const ErrorAlertBox = styled(AlertBoxBase)`
	color: var(--color-error-on-container);
	background: var(--color-error-container);
`;

export const InfoAlertBox = styled(AlertBoxBase)`
	color: var(--color-info-on-container);
	background: var(--color-info-container);
`;
/* Alert box [END] */
